import request from '../../utils/request'

const preFix = '/merchant';

export const reqListMerChant = (data) => {
    return request({
        url: preFix + '/list',
        method: 'POST',
        data: data
    })
}
export const reqInsertMerChant = (data) => {
    return request({
        url: preFix + '/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateMerChant = (data) => {
    return request({
        url: preFix + '/update',
        method: 'POST',
        data: data
    })
}
export const reqDeleteMerChantById = (data) => {
    return request({
        url: preFix + '/delete',
        method: 'get',
        params: data
    })
}
export const reqGetMerChantById = (data) => {
    return request({
        url: preFix + '/detail',
        method: 'get',
        params: data
    })
}
